module.exports = __webpack_public_path__ + "static/media/tamweely.92c821fc.jpeg";